import React from 'react';

const getCurrentTheme = () => {
  if (typeof window === 'undefined') {
    return 'light';
  }

  try {
    return localStorage.getItem('theme_preference') === 'dark' ? 'dark' : 'light';
  } catch (error) {
    return 'light';
  }
};

const ResumoCardContratos = ({
  titulo,
  tituloMobile,
  valor,
  subtitulo,
  _subtituloValor,
  icone: Icon,
  corIcone = 'blue',
  corValor = 'gray-900',
  className = '',
  valorCompleto,
  featured = false
}) => {
  const currentTheme = getCurrentTheme();
  const isDark = currentTheme === 'dark';
  const isReactElement = React.isValidElement(valor);

  const toneClasses = {
    blue: '#38bdf8',
    green: '#34d399',
    red: '#fb7185',
    yellow: '#fbbf24',
    purple: '#a78bfa',
    pink: '#f472b6',
    gray: '#94a3b8',
    orange: '#fb923c',
    indigo: '#818cf8'
  };

  const corClasses = {
    'gray-900': 'text-[color:var(--text-primary)]',
    'green-600': isDark ? 'text-emerald-300' : 'text-emerald-700',
    'red-600': isDark ? 'text-rose-300' : 'text-rose-700',
    'blue-600': isDark ? 'text-sky-300' : 'text-sky-700',
    'purple-600': isDark ? 'text-purple-300' : 'text-purple-700',
    'orange-600': isDark ? 'text-orange-300' : 'text-orange-700'
  };

  const tone = toneClasses[corIcone] || toneClasses.blue;
  const cardTheme = isDark
    ? 'border-slate-800/70 bg-[color:var(--surface)]/92 shadow-[0_10px_28px_rgba(2,6,23,0.18)]'
    : 'border-slate-200/80 bg-white shadow-[0_12px_26px_rgba(15,23,42,0.08)]';
  const featuredShell = featured
    ? 'min-h-[132px] sm:min-h-[140px] p-4 sm:p-5'
    : 'min-h-[118px] sm:min-h-[128px] p-3.5 sm:p-4';

  return (
    <div
      className={`group relative h-full overflow-hidden rounded-[18px] border backdrop-blur transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_30px_rgba(2,6,23,0.14)] focus-within:ring-1 focus-within:ring-[color:var(--border)] ${cardTheme} ${featuredShell} ${className}`}
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[color:var(--accent)]/22 to-transparent" />
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-1.5 rounded-r-full opacity-90"
        style={{ backgroundColor: tone }}
      />

      <div className="relative flex h-full flex-col gap-3 pl-2">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className={`font-semibold text-[10px] uppercase tracking-[0.22em] sm:text-xs ${isDark ? 'text-[color:var(--text-muted)]' : 'text-slate-500'}`}>
              <span className="sm:hidden">{tituloMobile || titulo}</span>
              <span className="hidden sm:inline">{titulo}</span>
            </p>
            <p className={`mt-1 max-w-[32ch] text-xs leading-relaxed sm:text-sm ${isDark ? 'text-[color:var(--text-muted)]' : 'text-slate-600'}`}>
              {subtitulo}
            </p>
          </div>

          {Icon && (
            <div className={`flex-shrink-0 rounded-2xl border p-2 ${
              isDark
                ? 'border-slate-700/70 bg-slate-900/60 text-[color:var(--text-primary)]'
                : 'border-slate-200 bg-white text-slate-700 shadow-[0_4px_12px_rgba(15,23,42,0.06)]'
            }`}>
              <Icon className="h-4 w-4 sm:h-5 sm:w-5" style={{ color: tone }} />
            </div>
          )}
        </div>

        <div className="mt-auto min-w-0 border-t border-dashed border-current/8 pt-3">
          {isReactElement ? (
            <div className="flex flex-col justify-center">
              {valor}
            </div>
          ) : (
            <div
              className={`font-bold ${corClasses[corValor] || 'text-[color:var(--text-primary)]'} leading-none tracking-tight tabular-nums ${
                featured ? 'text-[1.8rem] sm:text-[2.15rem]' : 'text-[1.55rem] sm:text-[1.95rem]'
              }`}
              title={valorCompleto && valorCompleto !== valor ? `Valor completo: ${valorCompleto}` : undefined}
            >
              {valor}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumoCardContratos;
